"use client";

import type { ButtonHTMLAttributes, ReactNode } from "react";

export interface GlassPillButtonProps
	extends ButtonHTMLAttributes<HTMLButtonElement> {
	readonly selected?: boolean;
	readonly children: ReactNode;
}

/**
 * GlassPillButton — selectable pill used inside `GlassTabPill` or standalone.
 * The selected state inverts to a higher-contrast fill.
 */
export function GlassPillButton({
	selected = false,
	children,
	className = "",
	...props
}: Readonly<GlassPillButtonProps>) {
	return (
		<button
			className={`ds-pill-button${selected ? " ds-pill-button--selected" : ""} ${className}`.trim()}
			aria-pressed={selected}
			{...props}
		>
			{children}
		</button>
	);
}
